module.exports = __webpack_public_path__ + "static/img/photo2.8d1cd037.jpg";